<section [formGroup]="formGroup"
         class="card-highlight-background">
    <h2 translate> {{ 'settings_deployment_' + nugetType }} </h2>

    <!-- FEED SOURCE OPTIONS-->
    <ng-container *ngIf="hasMultipleFeedSources">
        <h3 translate>settings_deployment_feed_source</h3>
        <mat-radio-group [formControlName]="DeploymentGeneralSettingsControl.useSharedFeed"
                         (change)="onFeedSourceRadioChange($event)"
                         class="deployment-radio-group"
                         data-cy="deployment-source">
            <mat-radio-button [value]="true"
                              data-cy="host-feed">
                {{ 'settings_deployment_host' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false"
                              data-cy="tenant-feed">
                {{ 'settings_deployment_tenant' | translate }}
            </mat-radio-button>
        </mat-radio-group>
    </ng-container>

    <ng-container *ngIf="(feedSourceChanges$ | async) === 'tenant'">

        <!-- INTERNAL/EXTERNAL OPTIONS-->
        <h3 translate>settings_deployment_type</h3>
        <mat-radio-group [formControlName]="DeploymentGeneralSettingsControl.isInternalDeployment"
                         (change)="onDeploymentTypeRadioChange($event)"
                         class="deployment-radio-group"
                         data-cy="deployment-type">
            <mat-radio-button [value]="true"
                              data-cy="internal-feed">
                {{ 'settings_deployment_internal' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false"
                              data-cy="external-feed">
                {{ 'settings_deployment_external' | translate }}
            </mat-radio-button>
        </mat-radio-group>

        <!-- EXTERNAL DEPLOYMENT URL -->
        <ng-container *ngIf="!formGroup?.get(DeploymentGeneralSettingsControl.isInternalDeployment).value">
            <mat-form-field
                            *ngLet="formGroup?.get(DeploymentGeneralSettingsControl.externalDeploymentUrl) as deploymentUrlField">
                <input [formControlName]="DeploymentGeneralSettingsControl.externalDeploymentUrl"
                       [placeholder]="'settings_deployment_form_url' | translate"
                       [refocus]="!formGroup?.get(DeploymentGeneralSettingsControl.isInternalDeployment).value"
                       [uiAutofocus]
                       matInput
                       required
                       data-cy="external-deploy-url" />
                <mat-error *ngIf="deploymentUrlField.hasError('regex')"
                           translate>
                    settings_deployment_form_url_warning
                </mat-error>
                <mat-error *ngIf="deploymentUrlField.hasError('maxlength')"
                           [translateParams]="{
                                       max: deploymentUrlField.getError('maxlength').requiredLength
                               }"
                           translate>
                    settings_deployment_form_url_max_warning
                </mat-error>
            </mat-form-field>
        </ng-container>

        <h4 translate>
            settings_deployment_form_security_label
        </h4>

        <!-- AUTHENTICATION OPTIONS RADIO BUTTONS-->
        <mat-radio-group [formControlName]="DeploymentGeneralSettingsControl.selectedAuthenticationType"
                         (change)="onAuthenticationTypeRadioChange($event)"
                         data-cy="auth-options">
            <ng-container *ngFor="let authenticationTypeFormGroupName of authenticationTypeFormGroupNamesOrdered">
                <ng-container
                              *ngLet="getAuthenticationTypeFormGroupByName(authenticationTypeFormGroupName) as authenticationTypeFormGroup">
                    <ng-container [formGroup]="authenticationTypeFormGroup"
                                  [ngSwitch]="authenticationTypeFormGroupName">

                        <!-- SECURE AUTHENTICATION -->
                        <ng-container *ngSwitchCase="DeploymentAuthenticationType.secure">
                            <mat-radio-button [value]="DeploymentAuthenticationType.secure"
                                              data-cy="secure-deployment">
                                {{ 'settings_deployment_form_secure' | translate }}
                            </mat-radio-button>
                            <mat-hint translate>
                                settings_deployment_form_secure_description
                            </mat-hint>
                        </ng-container>

                        <!-- API KEY AUTHENTICATION-->
                        <ng-container *ngSwitchCase="DeploymentAuthenticationType.apiKey">
                            <mat-radio-button [value]="DeploymentAuthenticationType.apiKey"
                                              data-cy="api-deployment">
                                {{ 'settings_deployment_form_api_key' | translate }}
                            </mat-radio-button>
                            <mat-form-field
                                            *ngLet="authenticationTypeFormGroup.get(DeploymentAuthenticationTypeControl.apiKey) as apiKeyField">
                                <input [formControlName]="DeploymentAuthenticationTypeControl.apiKey"
                                       matInput
                                       data-cy="api-key" />
                                <mat-error *ngIf="!apiKeyField.hasError('whitespace') &&
                                                       apiKeyField.hasError('maxlength')"
                                           [translateParams]="{
                                                   max: apiKeyField.getError('maxlength').requiredLength
                                               }"
                                           translate>
                                    settings_deployment_form_api_key_max_warning
                                </mat-error>
                            </mat-form-field>
                        </ng-container>

                        <!-- BASIC AUTHENTICATION -->
                        <ng-container *ngSwitchCase="DeploymentAuthenticationType.basicAuth">

                            <mat-radio-button [value]="DeploymentAuthenticationType.basicAuth"
                                              class="deployment-basic-auth"
                                              data-cy="auth-deployment">
                                {{ 'settings_deployment_form_authentication' | translate }}
                            </mat-radio-button>

                            <!-- BASIC AUTH USERNAME -->
                            <mat-form-field
                                            *ngLet="authenticationTypeFormGroup.get(DeploymentAuthenticationTypeControl.basicAuthUsername) as usernameField">
                                <input [formControlName]="DeploymentAuthenticationTypeControl.basicAuthUsername"
                                       [placeholder]="'settings_deployment_form_username' | translate"
                                       matInput
                                       uiPreventAutofill
                                       data-cy="auth-username" />
                                <mat-error *ngIf="!usernameField.hasError('whitespace') &&
                                                       usernameField.hasError('maxlength')"
                                           [translateParams]="{
                                                       max: usernameField.getError('maxlength').requiredLength
                                               }"
                                           translate>
                                    settings_deployment_form_username_max_warning
                                </mat-error>
                            </mat-form-field>

                            <!-- BASIC AUTH PASSWORD -->
                            <mat-form-field
                                            *ngLet="authenticationTypeFormGroup.get(DeploymentAuthenticationTypeControl.basicAuthPassword) as passwordField">
                                <input [formControlName]="DeploymentAuthenticationTypeControl.basicAuthPassword"
                                       [placeholder]="'settings_deployment_form_password' | translate"
                                       matInput
                                       type="password"
                                       uiPreventAutofill
                                       data-cy="auth-password" />
                                <mat-error *ngIf="!passwordField.hasError('whitespace') &&
                                                       passwordField.hasError('maxlength')"
                                           [translateParams]="{
                                                       max: passwordField.getError('maxlength').requiredLength
                                               }"
                                           translate>
                                    settings_deployment_form_password_max_warning
                                </mat-error>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-radio-group>
        <mat-error *ngIf="formGroup.hasError('invalidSelection')"
                   translate>
            settings_deployment_form_no_option_selected
        </mat-error>

        <!-- ALLOW HOST FEED UPLOAD FROM TENANT OPTION -->
        <ng-container *ngIf="showTenantPublishOptions">
            <mat-checkbox [formControlName]="DeploymentGeneralSettingsControl.allowTenantPublish"
                          data-cy="allow-host-feed">
                {{ 'settings_deployment_allow_share_feed_upload' | translate }}
            </mat-checkbox>
        </ng-container>
    </ng-container>
</section>
